import * as BN from 'bn.js';
import { SYSTEM_DECIMALS } from '../parsers/config';
export const formatSeparator = (balance, precision) => {
  if (balance.length <= precision) {
    return formatSeparator([...new Array(precision + 1 - balance.length).fill('0'), balance].join(''), precision);
  }

  const whole = precision > 0 ? balance.slice(0, -precision) : balance;
  const fraction = precision > 0 ? balance.slice(-precision) : '';
  const wholeWithFragment = whole.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return !fraction ? wholeWithFragment : `${wholeWithFragment}.${fraction}`;
};
export const formatWholeFraction = value => {
  return value.replace(/^([-+]?[\d,]*[\d.]*?)\.?0*$/g, '$1');
};
export const makeCurrencyFormatter = defaultConfig => (currency, config) => {
  const {
    symbol,
    precision = 0,
    symbolInFront,
    withCurrency,
    trimWholeFraction,
    showPlusSign
  } = Object.assign({}, defaultConfig, config);
  const p = Math.min(Math.max(precision, 0), SYSTEM_DECIMALS);
  const decimals = SYSTEM_DECIMALS - p;
  const multiplier = new BN.BN(['1', ...new Array(decimals).fill('0')].join(''));
  const valueBN = new BN.BN(currency.value);
  let value = valueBN.div(multiplier).toString();
  const isNegativeNum = value.slice(0, 1) === '-';

  if (isNegativeNum) {
    value = value.slice(1, value.length);
  }

  let valueWithSeparator = `${isNegativeNum ? '-' : `${showPlusSign ? '+' : ''}`}${formatSeparator(value, p)}`;

  if (trimWholeFraction) {
    valueWithSeparator = formatWholeFraction(valueWithSeparator);
  }

  if (!withCurrency) {
    return valueWithSeparator;
  }

  return symbolInFront ? `${symbol} ${valueWithSeparator}` : `${valueWithSeparator} ${symbol}`;
};
export const makeItemFormatter = defaultConfig => (item, config) => {
  const {
    symbol,
    precision = 0,
    symbolInFront,
    withCurrency,
    trimWholeFraction,
    showPlusSign
  } = Object.assign({}, defaultConfig, config);
  const p = Math.min(Math.max(precision, 0), item.decimals);
  const decimals = item.decimals - p;
  const multiplier = new BN.BN(['1', ...new Array(decimals).fill('0')].join(''));
  const valueBN = new BN.BN(item.value);
  let value = valueBN.div(multiplier).toString();
  const isNegativeNum = value.slice(0, 1) === '-';

  if (isNegativeNum) {
    value = value.slice(1, value.length);
  }

  let valueWithSeparator = `${isNegativeNum ? '-' : `${showPlusSign ? '+' : ''}`}${formatSeparator(value, p)}`;

  if (trimWholeFraction) {
    valueWithSeparator = formatWholeFraction(valueWithSeparator);
  }

  if (!withCurrency) {
    return valueWithSeparator;
  }

  return symbolInFront ? `${symbol} ${valueWithSeparator}` : `${valueWithSeparator} ${symbol}`;
};